var map = {
	"./fonts/BeautifulPeoplePersonalUse-dE0g.ttf": 8206,
	"./fonts/Raleway-VariableFont_wght.ttf": 4381,
	"./home/picture_1.png": 5563,
	"./home/picture_2.png": 1041,
	"./home/picture_3.png": 8194,
	"./home/picture_4.png": 8369,
	"./logo.png": 6949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;